<div class="modal" id="classDetail" tabindex="-1">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="container-fluid bg-light-gray p-0">
          <div class="row row-cols-1 gy-2 m-0">
            <div class="col mt-0 bg-primary-white navbar-spacer">
              <app-navbar
                class="fixed-top"
                [isShowBackButton]="true"
                [preventDefaultGoBack]="true"
                (goBackCallback)="hide()"
                [inputTitle]="'app.navbar.classDetails'"
              />
            </div>
            <div class="col col-lg-6 py-3 px-4 bg-primary-white">
              <div class="fs-4 fw-bold text-secondary-purple">
                {{ clazz?.date ?? '' | myDate }}
              </div>
              <div class="text-secondary fs-5">
                {{ clazz?.date ?? '' | myDate: true }}
              </div>
            </div>
            <div class="col col-lg-6 py-3 px-4 bg-primary-white">
              <div class="mb-2 text-secondary-purple fw-bold">
                <span class="fas fa-circle text-accent-orange me-2"></span
                >{{ 'app.schedule.upcomingClass' | translate }} -
                @switch (clazz?.type) {
                  @case ('Independent Ride') {
                    {{ 'app.class.independentRide' | translate }}
                  }
                  @case ('Term Ride') {
                    {{ 'app.class.termRide' | translate }}
                  }
                  @case ('Group Ride') {
                    {{ 'app.class.groupRide' | translate }}
                  }
                  @default {
                    {{ clazz?.type }}
                  }
                }
              </div>
              <div class="fs-5 fw-bold mb-2">{{ clazz?.venue }}</div>
              <div class="text-secondary">
                <span class="far fa-clock me-1"></span>
                {{ clazz?.shortTimeStart() }} - {{ clazz?.shortTimeEnd() }} ·
                {{ clazz?.getDuration()
                }}{{ 'app.leaveRequest.mins' | translate }}
              </div>
              <div class="text-secondary">
                <span class="fas fa-user-tie me-2"></span>
                {{ riders.length }} {{ 'app.details.unitRiders' | translate }}
              </div>
            </div>
            @if (isCoach) {
              <div class="col bg-primary-white p-0">
                <div
                  (click)="showRiderAttendance()"
                  class="px-4 py-3 d-flex justify-content-between align-items-center"
                >
                  <div>
                    {{ 'app.details.confirmRidersAttendance' | translate }}
                  </div>
                  <div>
                    <span class="fas fa-angle-right text-secondary"></span>
                  </div>
                </div>
                <div class="border-top mx-4"></div>
                <div
                  (click)="showVolunteerAttendance()"
                  class="px-4 py-3 d-flex justify-content-between align-items-center"
                >
                  <div>
                    {{ 'app.details.confirmVolunteersAttendance' | translate }}
                  </div>
                  <div>
                    <span class="fas fa-angle-right text-secondary"></span>
                  </div>
                </div>
                @defer {
                  <app-rider-attendance></app-rider-attendance>
                  <app-volunteer-attendance></app-volunteer-attendance>
                }
                <div class="border-top mx-4"></div>
                <div
                  (click)="showRiderPairing()"
                  class="px-4 py-3 d-flex justify-content-between align-items-center"
                >
                  <div>
                    {{
                      'app.details.pairHorseEquipmentVolunteerWithRider'
                        | translate
                    }}
                  </div>
                  <div>
                    <span class="fas fa-angle-right text-secondary"></span>
                  </div>
                </div>
                @defer {
                  <app-rider-pairing
                    (onBack)="onPairingBack()"
                  ></app-rider-pairing>
                }
              </div>
            }
            <div class="col py-3 px-4 bg-primary-white">
              <div class="fs-4 fw-bold">
                {{ 'app.details.riders' | translate }}
              </div>
              @if (isRidersLoading) {
                <div class="ratio ratio-1x1">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="spinner-border text-secondary-purple"></div>
                  </div>
                </div>
              }
              <div
                class="row row-cols-2 row-cols-lg-4 justify-content-center mt-2 g-2"
              >
                @for (rider of riders; track $index) {
                  <div class="col">
                    <div
                      class="shadow rounded p-3"
                      (click)="showRiderDetail(rider)"
                    >
                      <div class="fs-5 fw-bold text-center">
                        {{ rider.name?.enName }}
                      </div>
                      <div class="fs-5 fw-bold text-center">
                        {{ rider.name?.cnName }}
                      </div>
                      <div class="text-center text-secondary mt-3">
                        @if (rider?.gender) {
                          <span
                            class="fas me-2 fs-5"
                            [class.fa-person]="rider.gender === 'male'"
                            [class.fa-person-dress]="rider.gender === 'female'"
                          ></span>
                        }
                        <span>{{ rider.weight }} · {{ rider.height }}</span>
                      </div>
                      @if (rider.leaveRequests?.length) {
                        <div class="p-2 bg-warning text-dark rounded mt-2">
                          <div>{{ 'app.details.remark' | translate }} :</div>
                          @for (leaveReq of rider.leaveRequests; track $index) {
                            <div class="text-break text-wrap">
                              {{
                                'app.details.leaveType.' + leaveReq.type
                                  | translate
                              }}
                              -
                              {{
                                'app.leaveRequest.' + leaveReq.status
                                  | translate
                              }}
                            </div>
                          }
                        </div>
                      }
                      @let diagLines = riderDisabilityLines(rider);
                      @if (diagLines.length) {
                        <div
                          class="p-2 bg-secondary-purple text-light rounded mt-2"
                        >
                          <div>{{ 'app.details.disability' | translate }}:</div>
                          <div class="text-break text-wrap">
                            @for (line of diagLines; track $index) {
                              <div>{{ line }}</div>
                            }
                          </div>
                        </div>
                      }
                      <div
                        class="p-2 bg-secondary-purple text-light rounded mt-2"
                      >
                        <div>
                          {{ 'app.details.walk' | translate }}:
                          {{
                            `app.details.${rider?.canWalk() ? 'yes' : 'no'}`
                              | translate
                          }}
                        </div>
                      </div>
                      <div
                        class="p-2 bg-secondary-purple text-light rounded mt-2"
                      >
                        <div>
                          {{
                            'app.details.photographsFilmingConsent' | translate
                          }}:
                          @if (rider?.agreeTakePhoto) {
                            {{ 'app.details.agreeTakePhoto' | translate }}
                          } @else {
                            {{ 'app.details.disagreeTakePhoto' | translate }}
                          }
                        </div>
                      </div>
                      <div class="border my-4"></div>
                      <div class="row text-secondary-purple gy-1">
                        <div class="col-2">
                          <span class="fas fa-user-group"></span>
                        </div>
                        <div class="col-10">
                          @let leaderName =
                            rider?.assignedVolunteers?.leader?.name;
                          @if (leaderName?.enName || leaderName?.cnName) {
                            <div>
                              {{ leaderName?.enName ?? '' }}
                            </div>
                            <div>
                              {{ leaderName?.cnName ?? '' }}
                            </div>
                          } @else {
                            <div>
                              {{ 'app.details.notAssigned' | translate }}
                            </div>
                          }
                        </div>
                        <div class="col-2">
                          <span class="fas fa-user-group"></span>
                        </div>
                        <div class="col-10">
                          @let helperName =
                            rider?.assignedVolunteers?.helper?.name;
                          @if (helperName?.enName || helperName?.cnName) {
                            <div>
                              {{ helperName?.enName ?? '' }}
                            </div>
                            <div>
                              {{ helperName?.cnName ?? '' }}
                            </div>
                          } @else {
                            <div>
                              {{ 'app.details.notAssigned' | translate }}
                            </div>
                          }
                        </div>
                        <div class="col-2">
                          <span class="fas fa-horse me-2"></span>
                        </div>
                        <div class="col-10">
                          @if (
                            rider?.assignedHorse?.id ||
                            rider?.assignedHorse?.name
                          ) {
                            <div>{{ rider?.assignedHorse?.id }}</div>
                            <div>{{ rider?.assignedHorse?.name }}</div>
                          } @else {
                            <div>
                              {{ 'app.details.notAssigned' | translate }}
                            </div>
                          }
                        </div>
                        <div class="col-2">
                          <span class="fas fa-helmet-safety"></span>
                        </div>
                        <div class="col-10">
                          @if (rider?.assignedEquipment?.name) {
                            <div>{{ rider?.assignedEquipment?.name }}</div>
                          } @else {
                            <div>
                              {{ 'app.details.notAssigned' | translate }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
@defer {
  <app-rider-detail [isCoach]="isCoach"></app-rider-detail>
}
